module.exports = __webpack_public_path__ + "MagnetWeeb.jpg?9e785cb5a913f7d88d281ac8aea13293";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MagnetWeeb.jpg
// module id = 524
// module chunks = 0